import {TableHead} from "@hosttools/frontend/components";

export default TableHead;
